import { useVideoConferenceContext } from '../../hooks';
import { useParticipants } from '@livekit/components-react';
import { Participant } from './Participant';

export const Participants = () => {
  const participants = useParticipants();
  const { extendedWidgetState } = useVideoConferenceContext();

  return (
    extendedWidgetState.showParticipants && (
      <div className="flex gap-2 flex-col z-50 items-start p-2" style={{ width: 'clamp(200px, 40ch, 50ch)' }}>
        <div className="flex items-center justify-center h-[60px] w-full">
          <div className="block">Participants</div>
        </div>
        <div className="flex flex-col w-full gap-2 h-100 overflow-y-auto">
          {participants.map((participant) => (
            <Participant key={participant.identity} participant={participant} />
          ))}
        </div>
      </div>
    )
  );
};
